import { createStore } from "vuex";
import router from '@/router/index';

export default createStore({
  state: {
    isRegistered: false,
    project_id: localStorage.getItem('project_id') || null,
    workflow_id: localStorage.getItem('workflow_id') || null,
    custom_service_id: localStorage.getItem('custom_service_id') || null,
    client_id: localStorage.getItem('client_id') || null,
    service_id: localStorage.getItem('service_id') || null,
    user_role: localStorage.getItem('user_role') || null,
    user_id: localStorage.getItem('user_id') || null,
    unread_workbench_count: 0,
    current_application: null,
    entity_data_capture_config: null,
    camera_state: null,
    branding: {
      primary_color: "#59FF74",
      secondary_color: "#212529",
      logo_width: "100px",
      client_text: "dark",
      primary_color_rgb: "rgb(89, 255, 116)",
      secondary_color_rgb: "rgb(33, 37, 41)",
      icon_filter: "",
      table_header_bg: "#59FF74",
      sidebar_bg: "",
      sidebar_theme: "dark",
      sidebar_text_color: "",
      sidebar_link_color: "",
      sidebar_active_bg: "#59FF74",
      sidebar_hover_bg: "#59FF74",
      welcome_text: "",
      subtext: "Your trusted partner for verification and compliance",
      button_text: "Get Started",
      footer_text: "© 2024 TGPDC. All rights reserved.",
      app_footer_text: null,
      landing_url: null,
      logo_url: null,
      footer_logo_url: null,
      phone_countries: [],
    },
  },
  mutations: {
    setUserRegistered(state) {
      state.isRegistered = true;
    },
    set_project_id(state, project_id) {
      state.project_id = project_id;
      localStorage.setItem('project_id', project_id);
    },
    set_workflow_id(state, id) {
      state.workflow_id = id;
      localStorage.setItem('workflow_id', id);
    },
    clear_workflow_id(state) {
      state.workflow_id = null;
      localStorage.removeItem('workflow_id');
    },
    set_client_id(state, client_id) {
      state.client_id = client_id;
      localStorage.setItem('client_id', client_id);
    },
    set_service_id(state, id) {
      state.service_id = id;
      localStorage.setItem('service_id', id);
    },
    set_user_role(state, role) {
      state.user_role = role;
      localStorage.setItem('user_role', role);
    },
    set_user_id(state, user_id) {
      state.user_id = user_id;
      localStorage.setItem('user_id', user_id);
    },
    set_unread_workbench_count(state, count) {
      state.unread_workbench_count = count;
    },
    set_current_application(state, app) {
      state.current_application = app;
    },
    clear_current_application(state) {
      state.current_application = null;
    },
    set_entity_data_capture_config(state, config) {
      state.entity_data_capture_config = config;
    },
    clear_entity_data_capture_config(state) {
      state.entity_data_capture_config = null;
    },
    set_branding(state, branding) {
      state.branding = { ...state.branding, ...branding };
    },
    SET_CAMERA_STATE(state, value) {
      state.camera_state = value;
    },
  },
  actions: {
    registerUser({ commit }) {
      commit('setUserRegistered');
      router.push({ name: 'user_otp' });
    },
    update_workflow_id({ commit }, id) {
      commit("set_workflow_id", id);
    },
    update_project_id({ commit }, project_id) {
      commit('set_project_id', project_id);
    },
    update_client_id({ commit }, client_id) {
      commit('set_client_id', client_id);
    },
    update_service_id({ commit }, service_id) {
      commit('set_service_id', service_id);
    },
    update_user_role({ commit }, user_role) {
      commit('set_user_role', user_role);
    },
    update_user_id({ commit }, user_id) {
      commit('set_user_id', user_id);
    },
    update_unread_workbench_count({ commit }, count) {
      commit('set_unread_workbench_count', count);
    }
  },
  getters: {
    isRegistered: state => state.isRegistered,
    get_workflow_id: (state) => state.workflow_id,
    get_branding: (state) => state.branding,
    get_project_id: (state) => state.project_id,
    get_client_id: (state) => state.client_id,
    get_service_id: (state) => state.service_id,
    get_user_role: (state) => state.user_role,
    get_user_id: (state) => state.user_id,
    get_unread_workbench_count: state => state.unread_workbench_count,
    get_entity_data_capture_config: state => state.entity_data_capture_config
  },
});
